<script>
import ShiftInfoComponent from '@/components/ShiftInfoComponent'
import RightLayout from '../layouts/rightLayout'
export default {
  components: {ShiftInfoComponent, RightLayout},
  data () {
    return {
      // 便情報
      // shiftBasicModel: {
      //   // 便ID
      //   shiftId: '',
      //   // 便名称
      //   title: '',
      //   // 便タイプ
      //   shiftType: '1',
      //   // イベントID
      //   eventId: null,
      //   // ルートID
      //   routeId: '',
      //   // ルート名
      //   routeName: '',
      //   // フリガナ
      //   driverKanaName: '',
      //   // ドライバーUID
      //   driverUid: null,
      //   // ドライバー名
      //   driverName: '',
      //   // 車両ID
      //   vehicleId: '',
      //   // 車両名
      //   vehicleName: '',
      //   // 地区ID
      //   areaId: null,
      //   // 地区名
      //   areaName: '',
      //   // 車両限制人数
      //   passengerNumber: '',
      //   // 運行日
      //   moveShiftTime: '',
      //   // 公開フラグ
      //   openFlag: '0',
      //   // 行帰フラグ
      //   shiftFlag: '0',
      //   // 出発予定時台
      //   startEstimateTimeSlot: null,
      //   // 到着予定時台
      //   arriveEstimateTimeSlot: null,
      //   // 利用料金
      //   shiftCost: 300
      // },
      // 便リスト
      shiftList: [{
        frontId: '0000',
        shiftEvent: null,
        // shiftBasicModel
        shiftBasic: {
            // 便Id(重新生成)
            shiftId: '',
            // 便名称（update）
            title: '',
            // ルートID
            routeId: '',
            // ルートName
            routeName: '',
            // ドライバーUID  （update）
            driverUid: '',
            // 車両ID  （update）
            vehicleId: '',
            // 運行日
            moveShiftTime: '',
            // 行帰フラグ
            shiftFlag: '0',
            // 出発予定時台  (对应shiftFlag: '0'  ？？？？？？写下面还是上面)
            startEstimateTimeSlot: '',
            // 到着予定時台 (对应shiftFlag: '1'  ？？？？？？？)
            arriveEstimateTimeSlot: '',
            // 利用料金  （update）
            shiftCost: 0,
            // イベントID
            eventId: '',
            // フリガナ
            driverKanaName: '',
            // ドライバー
            driverName: '',
            // 車両？？？？
            vehicleName: '',
            // 車両定員人数？？？？
            passengerNumber: '',
            // 便タイプ
            shiftType: '1',
            // 公開フラグ
            openFlag: 0,
            // 地区ID
            areaId: '',
            // 地区名
            areaName: '',
            // 交通事業者区分
            transportKind: 0,
            // 親便ID
            parentShiftId: '',
            // 元便ID
            oldShiftId: '',
            // 予約人数
            reserveNumber: 0,
            // 運行状態
            shiftMovementStatus: 3,
            businessStatus: 3,
            // コメント
            comment: '',
        },
        // shiftPasspoint
        shiftPasspointList: [],
        functionFlag: '0',
        loopDateList: null,
        // shiftReservationInfos
        shiftReservationInfoList: [],
        // 時刻リスト
        hourList: [],
        minuteList: [],
        timeList: [],
        shiftTimeInfoList: [],
        // ドライバー情報
        shiftTimeInfoListByDriverUid: [],
        // 車両情報
        selectedVehicle: [],
        routeType: '0',
        // ルート選択フラグ
        routeSelected: false,
        // 停留所一覧
        stationList: [{
          routeId: '',
          routeName: '',
          stationName: '',
                    }
        ],
      }],
      shiftConnectList: [
        {
        frontShiftConnect: {
          shiftId: '0000',
          connectSourceShiftId: '0000',
          stationId: '',
          connectSourceStationId: '',
          stationTime: '',
          connectSourceStationTime: '',
          stationUseTime: 0,
          errorMessage: '',
          timeError: 0
        },
        shiftConnect: {
          shiftId: '',
          connectSourceShiftId: '',
          stationId: '',
          connectSourceStationId: '',
          stationUseTime: 0
        },
      }],
    }
  }
}
</script>

<template>
<right-layout>
<Shift-info-component
    :title="'このルートで便を登録'"
    :btnName="'登録'"
    :shiftList=shiftList
    :shiftConnectList=shiftConnectList
    :functionFlag="'2'"
    ></Shift-info-component>
</right-layout>
</template>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/router/views/RouteShiftLogin.vue